import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import i18n from "./i18n";

loadFonts();

// const app = createApp(App);

// app.use(router);
// app.use(store);
// app.use(i18n);
// app.use(vuetify);
// app.mount("#app");

async function bootstrap() {
  // Fetch the theme colors before mounting the app
  await store.dispatch("fetchColors");

  // Get colors from Vuex store
  const colors = store.getters["getColorsObject"];
  console.log("Fetched colors object:", colors);
  console.log("Fetched colors object:", colors.primary);
  console.log("Fetched colors object:", colors.colors.primary);

  // Re-create Vuetify with dynamic colors
  import("./plugins/vuetify-dynamic").then(({ createVuetifyDynamic }) => {
    // Pass colors to createVuetifyDynamic
    const vuetifyInstance = createVuetifyDynamic(colors.colors);
    const app = createApp(App);
    app.use(router);
    app.use(store);
    app.use(i18n);
    app.use(vuetifyInstance);
    app.mount("#app");
  });
}

bootstrap();
